import { createContext, useContext, useState } from 'react';

const FileContext = createContext();

export const FileProvider = ({ children }) => {
  const [fileData, setFileData] = useState({
    idCopy: null,
    matricCertificate: null,
    transcripts: null,
    proofOfPayment: null,
    pastoralReference: null,
  });

  const setFile = (fileType, file) => {
    setFileData((prevData) => ({ ...prevData, [fileType]: file }));
  };

  return (
    <FileContext.Provider value={{ fileData, setFile }}>
      {children}
    </FileContext.Provider>
  );
};

export const useFileContext = () => {
  return useContext(FileContext);
};
